import { render, staticRenderFns } from "./joins.vue?vue&type=template&id=99b31e32&scoped=true&"
import script from "./joins.vue?vue&type=script&lang=js&"
export * from "./joins.vue?vue&type=script&lang=js&"
import style0 from "./joins.vue?vue&type=style&index=0&id=99b31e32&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99b31e32",
  null
  
)

export default component.exports